import React from "react";
import type { MatchTimelineEvent } from "./types";
import { Text } from "components/common/Text";

type EventDetailsProps = {
  event: MatchTimelineEvent;
  team: "home" | "away";
  homeColor?: string;
  awayColor?: string;
  icons?: Record<string, React.ReactNode>;
};

const EventDetails: React.FC<EventDetailsProps> = ({
  event,
  team,
  homeColor,
  awayColor,
  icons,
}) => {
  const isHome = team === "home";
  const isActive = team === event.team;

  const iconKey = event.iconKey ?? event.type;
  const iconNode = icons?.[iconKey] ?? null;

  const containerClasses = [
    "flex w-[45%] items-center gap-[2vw]",
    isHome ? "justify-end text-right" : "justify-start text-left",
  ]
    .filter(Boolean)
    .join(" ");

  const lineColor =
    team === "home"
      ? homeColor || "var(--home-color)"
      : awayColor || "var(--away-color)";

  if (!isActive) return <div className={containerClasses} />;

  const description = (
    <div className="max-w-[80%] overflow-hidden">
      {event.title && (
        <div className="truncate font-semibold">
          <Text variant="timelineEventTitle">{event.title}</Text>
        </div>
      )}
      {event.subtitle && (
        <div className="truncate text-gray-400">
          <Text variant="timelineEventDescription">{event.subtitle}</Text>
        </div>
      )}
    </div>
  );

  const iconSection = (
    <div className="flex h-[7vw] w-[7vw] items-center justify-center gap-[2vw]">
      {isHome && (
        <>
          <div
            className="h-[5vw] w-[0.5vw]"
            style={{ backgroundColor: lineColor }}
          />
          <div className="flex h-[6vw] w-[6vw] items-center justify-center">
            {iconNode}
          </div>
        </>
      )}
      {!isHome && (
        <>
          <div className="flex h-[6vw] w-[6vw] items-center justify-center">
            {iconNode}
          </div>
          <div
            className="h-[5vw] w-[0.5vw]"
            style={{ backgroundColor: lineColor }}
          />
        </>
      )}
    </div>
  );

  return (
    <div className={containerClasses}>
      {isHome ? (
        <>
          {description}
          {iconSection}
        </>
      ) : (
        <>
          {iconSection}
          {description}
        </>
      )}
    </div>
  );
};

export default EventDetails;
